import type { LaunchCreateSearch } from "@/lib/search-params";
import { trpcClient } from "@/lib/trpc";

export type LaunchCreateLoaderDeps = Pick<LaunchCreateSearch, "sheet" | "platform">;

export type LaunchCreateLoaderInput = {
  deps: LaunchCreateLoaderDeps;
  params: { orgSlug: string };
};

export async function loadLaunchCreateData({ deps, params }: LaunchCreateLoaderInput) {
  const [viewer, sheets, tiktokConnection] = await Promise.all([
    trpcClient.organization.viewer.query(),
    trpcClient.launchCreate.listSheets.query({
      orgSlug: params.orgSlug,
      selectedSheetId: deps.sheet,
    }),
    trpcClient.tiktok.connection.query({ orgSlug: params.orgSlug }),
  ]);
  return { viewer, sheets, tiktokConnection };
}

export type LaunchCreateLoaderData = Awaited<ReturnType<typeof loadLaunchCreateData>>;

export interface LaunchCreateRouteHooks {
  useLoaderData: () => LaunchCreateLoaderData;
  useParams: () => { orgSlug: string };
  useSearch: () => LaunchCreateSearch;
}
